import { useState, useEffect } from 'react';
import api from '../../utils/api.js';
import Combo from '../common/Combo.jsx';
import '../../styles/routes/combosPage.css';

function CombosPage() {
    const [combos, setCombos] = useState([]);

    useEffect(() => {
        const fetchCombos = async () => {
            try {
                const response = await api.get('/combos');
                setCombos(response.data.combos);
            } catch (error) {
                console.error('Erro ao buscar combos:', error.message);
            }
        };

        fetchCombos();
    }, []);

    return (
        <div className='sectionCombos'>
            <h1>Combos</h1>
            {combos.length > 0 ? (
                combos.map((combo, index) => (
                    <Combo key={combo._id} combo={combo} isAlternate={index % 2 !== 0} />
                ))
            ) : (
                <p>Nenhum combo encontrado.</p>
            )}
        </div>
    );
}

export default CombosPage;
